<template>
 <div class="timeLine">
   <div class="t_show_block">
      <div class="show_box">
       <div class="box_title pangMen">
         <span class="title_time">
           {{current.time}}
         </span>
         <span>{{current.title}}</span>
       </div>
        <div class="box_font" v-html="current.content">

        </div>
      </div>
   </div>
   <div class="t_time_line">
     <div class="top_block">
       <div class="block_item" v-for="(item,index) in topList" :key="item.title">
         <div class="item_time pangMen" :class="{ active: topIndex === index}">
           {{item.time}}
         </div>
         <div class="item_name">
           {{item.title}}
         </div>
       </div>
     </div>
     <div class="t_line">
     </div>
     <div class="t_point">
       <div class="point_item" v-for="(item,index) in courseList" :key="item.title" :class="{ active: activeIndex === index}">
       </div>
     </div>
     <div class="arrowhead">
       <div class="triangle"></div>
     </div>
     <div class="bottom_block">
       <div class="block_item" v-for="(item, index) in bottomList" :key="item.title">
         <div class="item_time pangMen" :class="{ active: bottomIndex === index}">
           {{item.time}}
         </div>
         <div class="item_name">
           {{item.title}}
         </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import jsonData from '/public/static/js/json/operateManage.json';
export default {
  name: 'timeLine',
  data() {
    return {
      courseList: [

      ],
      current: '',
      topList: [],
      bottomList: [],
      activeIndex: 0,
      topIndex: 0,
      bottomIndex: 7,
      timer: null
    }
  },
  mounted() {
    this.courseList = jsonData.processIntroduce.courseList;
    this.courseList.forEach((i,index) => {
      if (index % 2 === 0) {
        this.topList.push(i);
      } else {
        this.bottomList.push(i);
      }
    });
    this.current = this.courseList[this.activeIndex];
    this.timer = setInterval(()=>{
      ++this.activeIndex;
      if(this.activeIndex > this.courseList.length - 1) {
        this.activeIndex = 0;
      }
      this.current = this.courseList[this.activeIndex];
       if (this.activeIndex % 2 === 0) {
         this.topIndex = this.activeIndex / 2;
         this.bottomIndex = 7;
       } else {
         this.topIndex = 7;
         this.bottomIndex = Math.floor(this.activeIndex / 2);
       }
    },6000);
  }
}
</script>

<style scoped lang="scss">
.timeLine {
  height: 100%;
  .t_show_block {
    height: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    .show_box {
      border: 1px solid #1abfb4;
      box-shadow: 1px 1px 5px #1abfb4;
      border-radius: 2px;
      height: 260px;
      width: 429px;
      .box_title {
        height: 47px;
        display: flex;
        background: linear-gradient(to right, #2ed9d6, #036360);
        justify-content: center;
        align-items: center;
        font-size: 24px;
        .title_time {
          margin-right: 10px;
        }

      }
      .box_font {
        padding: 10px;
        font-size: 18px;
        letter-spacing: 2px;
      }
    }
  }
  .t_time_line {
    height: 40%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .top_block {
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 83%;
      padding-left: 25px;
      .block_item {
        display: flex;
        align-items: center;
        flex-direction: column;
        .item_time {
          text-align: center;
          font-size: 24px;
        }
        .item_name {
          font-size: 18px;
        }
      }
      .active {
        color:#40e5e1 !important;
      }

    }
    .t_line {
      border: 2px dashed #ffffff;
    }
    .t_point {
      position: absolute;
      width: 100%;
      display: flex;
      justify-content: space-around;
      .point_item {
        transform: rotate(133deg);
        background: white;
        height: 15px;
        width: 15px;
      }
      .active {
        background: #40e5e1;
      }
    }
    .arrowhead {
      position: absolute;
      right: 0;
      .triangle {
        border-style: solid;
        border-color: transparent;
        border-width: 10px 0 10px 15px;
        border-left-color: white;
      }
    }
    .bottom_block {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      width: 80%;
      justify-content: space-between;
      margin-left: auto;
      padding-right: 20px;
      .block_item {
        display: flex;
        align-items: center;
        flex-direction: column;
        .item_time {
          text-align: center;
          font-size: 24px;
        }
        .item_name {
          font-size: 18px;
        }
      }
      .active {
        color: #40e5e1;
      }
    }
  }
}
</style>
